import React, { useEffect, useState } from "react";
import { locationService } from "../../services/location.service";
import { tS } from "../../services/translation.service";

interface IProps {
  locationCode: string;
  setIsGerman: (blind: boolean) => void;
  onNextStep: () => void;
  setScannedLocationId: (locationId: number) => void;
  defaultLanguage: number;
  setLocationName: (locationName: string) => void;
  setSelectedLanguage: (locationId: number) => void;
}

export const LanguageStep = (props: IProps) => {
  const { locationCode, setIsGerman, setScannedLocationId, setLocationName, onNextStep, defaultLanguage, setSelectedLanguage} = props;

  const [isSuccess, setSuccess] = useState(false);
  const [localLocationName, setLocalLocationName] = useState("");

  const onNextFlowHandler = (selectedLanguage: number) => {
    setSelectedLanguage(selectedLanguage)
    onNextStep();
  };

    useEffect(() => {
      locationService
        .getLocation(locationCode)
        .then((response) => {
          if (response) {
            setSuccess(true);
            setScannedLocationId(response.locationId);
            setLocalLocationName(response.locationName);
            setLocationName(response.locationName);
          } else {
            setSuccess(false);
          }
        })
        .catch(() => {
          setSuccess(false);
        });
    }, [locationCode, setLocationName, setScannedLocationId]);

  return (
    <div className="container">
      {isSuccess ? (
        <>
          <p>{tS.gT(tS.P.YouHave, defaultLanguage)} {localLocationName}{tS.gT(tS.P.Selected, defaultLanguage)}. <br/>
            {tS.gT(tS.P.SelectLanguage, defaultLanguage)}</p>
          
          {defaultLanguage != 2 && <p>You have selected the locker terminal named: {localLocationName}, <br/>
          Please select your language.</p>}

          {defaultLanguage == 2 && <button
            style={{ margin: 10 }}
            onClick={() => onNextFlowHandler(2)}
          >
            Slovenčina
          </button>}

            <button
            style={{ margin: 10 }}
            onClick={() => onNextFlowHandler(0)}
          >
            Deutsch
          </button>

          <button
            style={{ margin: 10 }}
            onClick={() => onNextFlowHandler(1)}
          >
            English
          </button>
        </>
      ) : (
        <div>loading</div>
      )}
    </div>
  );
};
